import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { notAllowedIcon } from "@/assets/default-icons";
import { usePermission } from "@/auth/session-provider";
import { StatusPage } from "@/components/status-page";
import { useI18n } from "@/locales/i18n-provider";

type RequirePermissionProps = {
  /** 任一命中即放行（any-of）。 */
  permissions: string[];
  /** 缺省渲染 `<Outlet />`，可当布局路由用；也可以直接包住一段 UI。 */
  children?: ReactNode;
};

/**
 * 路由级功能闸门。挡住的是"进错页面"，不是安全边界——
 * 真正的判权在服务端两段完成（Controller 功能闸门 + Application 范围判定）。
 */
export function RequirePermission({ permissions, children }: RequirePermissionProps) {
  const { canAny } = usePermission();
  const { t } = useI18n();

  if (permissions.length > 0 && !canAny(...permissions)) {
    return <StatusPage description={t("auth.permissionDenied.detail")} illustration={notAllowedIcon} title={t("auth.permissionDenied.title")} />;
  }

  return <>{children ?? <Outlet />}</>;
}
